import { Container } from "typedi";
import tronWeb from "tronweb";
import axios from "axios";
import { CONTRACT_ADDRESS } from "../../constants/tokens";
import { TRON_HOST } from "../../constants/config";
import { TransactionService } from "../../services";

export class BlocksService {
  public fetchBlocks = async (params) => {
    try {
      let transactionService = Container.get(TransactionService);
      const { dateRange, querySize, maxResults, existingBlocks } = params;
      if (!dateRange[0]._isAMomentObject || !dateRange[1]._isAMomentObject)
        throw new Error("Date range not valid!");

      const { fromTimestamp, toTimestamp, limit, max, orderBy, eventName } = {
        fromTimestamp: dateRange[0].format("x"),
        toTimestamp: dateRange[1].format("x"),
        limit: querySize,
        max: maxResults,
        orderBy: "block_timestamp,desc",
        eventName: "Transfer",
      };

      const cashTransactions = transactionService.getTransactions(
        CONTRACT_ADDRESS["cash"]!,
        fromTimestamp,
        toTimestamp,
        limit,
        max,
        orderBy,
        eventName
      );

      const riseTransactions = transactionService.getTransactions(
        CONTRACT_ADDRESS["rise"]!,
        fromTimestamp,
        toTimestamp,
        limit,
        max,
        orderBy,
        eventName
      );

      const [cashResults, riseResults] = await Promise.all([
        cashTransactions,
        riseTransactions,
      ]);
      const [riseTxns] = cashResults;
      const [cashTxns] = riseResults;

      const allTxns: any[] = [];
      riseTxns
        .map((txn) => ({ block: txn.block, date: txn.date, txid: txn.txid }))
        .forEach((txn) => allTxns.push(txn));

      cashTxns
        .map((txn) => ({ block: txn.block, date: txn.date, txid: txn.txid }))
        .forEach((txn) => allTxns.push(txn));

      const sortedTxns = allTxns
        .map((txn) => {
          const dupes = allTxns.filter((it) => it.block === txn.block);
          return {
            block: txn.block,
            txns: dupes.map((dupe) => dupe.txid),
            date: txn.date,
          };
        })
        .filter((v, i, a) => a.findIndex((t) => t.block === v.block) === i)
        .sort(function (a, b) {
          return b.date - a.date;
        })
        .slice(0, 15);

      const removeExisting = sortedTxns.filter(
        (txn) => !existingBlocks.find((ex) => ex.block === txn.block)
      );

      const blockPromises: any[] = [];
      for (var i = 0; i < removeExisting.length; i++) {
        blockPromises.push(
          axios
            .post(`${TRON_HOST}/wallet/getblockbynum`, {
              num: removeExisting[i].block,
            })
            .catch(function (error) {
              return {
                data: false,
              };
            })
        );
      }

      const blockData = await Promise.all(blockPromises);
      const blocks = blockData
        .filter((block) => {
          const { data } = block;
          return !!data;
        })
        .map((block) => {
          const { data } = block;
          return {
            block: data.block_header.raw_data.number,
            minerAddress: tronWeb.address.fromHex(
              data.block_header.raw_data.witness_address
            ),
          };
        });

      const uniqMiners = blocks.filter(
        (v, i, a) => a.findIndex((t) => t.minerAddress === v.minerAddress) === i
      );
      const minerPromises: any[] = [];
      for (var b = 0; b < uniqMiners.length; b++) {
        minerPromises.push(
          axios.post(`${TRON_HOST}/walletsolidity/getaccount`, {
            address: uniqMiners[b].minerAddress,
            visible: true,
          })
        );
      }

      const minerData = await Promise.all(minerPromises);

      const miners = minerData.map((miner) => {
        const { data } = miner;
        return {
          miner: data.account_name,
          address: data.address,
        };
      });

      const results = sortedTxns.map((txn) => {
        try {
          const block = blocks.find((bl) => bl.block === txn.block);
          const exist = existingBlocks.find((b) => b.block === txn.block);
          return {
            ...txn,
            miner: block
              ? miners.find((m) => m.address === block.minerAddress)
              : exist.miner,
          };
        } catch (e) {
          return txn;
        }
      });

      return {
        data: results,
      };
    } catch (e) {
      console.log(e);
      throw new Error("Error connecting to transaction service");
    }
  };
}
